<template>
  <div class="header-wrap">
    <div class="logo flex">
      <img src="@/assets/logo/logo.svg" style="width: 22px; height: 22px;margin-right:10px" alt />
      向海经济项目管理系统
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPage",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.header-wrap {
  background: #ffffff;
  .logo {
    width: 1200px;
    margin: 6px auto;
    align-items: center;
    font-weight: 600;
    color: #000;
    font-size: 22px;
  }
}
</style>